import { render, staticRenderFns } from "./fccCursoSuperior.vue?vue&type=template&id=8723adf8"
import script from "./fccCursoSuperior.vue?vue&type=script&lang=js"
export * from "./fccCursoSuperior.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports